module.exports = __webpack_public_path__ + "svg/confetti-bottom.svg";